<template>
  <div class="sanitasHealthForecastOverview">
    <div class="header-image" :class="headerImage ? 'withImage' : 'right'">
      <template v-if="headerBackgroundImage">
        <img
          :src="headerBackgroundImage"
          class="cover"
          :srcset="headerBackgroundImageSrcset"
        />
      </template>
      <health-forecast-header
        v-if="headerImage"
        :stoerer-active="stoererActive"
        :show-header-link="showHeaderLink"
        :header-link="headerLink"
        :header-link-target="headerLinkTarget"
        :header-link-stoerer-title="headerLinkStoererTitle"
        :header-title="headerTitle"
        :header-subtitle="headerSubtitle"
      >
        <img
          slot="image"
          :src="headerImage"
          class="header-img"
          :srcset="headerImageSrcset"
        />
      </health-forecast-header>
    </div>
    <div
      class="content-area"
      :class="{ 'content-area--no-image': !headerImage }"
    >
      <div class="content-column">
        <slot>slot?</slot>
      </div>
    </div>
    <slot name="footer"></slot>
  </div>
</template>

<script>
import HealthForecastHeader from '../common/HealthForecastHeader'

export default {
  name: 'SanitasHealthForecastOverview',

  components: {
    HealthForecastHeader,
  },

  props: {
    headerBackgroundImage: {
      type: String,
      default: '',
    },
    headerBackgroundImageSrcset: {
      type: String,
      default: '',
    },
    headerImage: {
      type: String,
      default: '',
    },
    headerImageSrcset: {
      type: String,
      default: '',
    },
    headerLinkStoererTitle: {
      type: String,
      default: '',
    },
    headerLink: {
      type: String,
      default: '',
    },
    headerLinkTarget: {
      type: String,
      default: '',
    },
    showHeaderLink: {
      type: String,
      default: 'false',
    },
    headerTitle: {
      type: String,
      default: '',
    },
    headerSubtitle: {
      type: String,
      default: () => '',
    },
    stoererActive: {
      type: String,
      default: 'false',
    },
  },
}
</script>

<style lang="postcss">
.sanitasHealthForecastOverview {
  position: relative;
  margin-left: calc(-1 * var(--body-offset-horizontal));
  margin-right: calc(-1 * var(--body-offset-horizontal));

  sup {
    top: -0.2em !important;
  }

  .header-image {
    position: relative;
    overflow: hidden;
    width: 100%;
    margin-left: auto;
    margin-right: auto;

    max-width: 860px;
    min-height: 200px;
    max-height: 200px;
    padding-bottom: 4%;
    background-color: var(--c-primary-neutral-1);

    .fluid {
      max-height: 750px;
      min-height: 200px;
      object-fit: cover;
    }

    &.right {
      min-height: auto;
      border-top: solid 1px var(--c-secondary-neutral-2);
      padding-top: 15px;
    }

    .cover {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      min-width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
  }

  .header-img {
    width: 82px;
    height: 105px;
    margin-right: 40px;
    display: block;
    margin-left: auto;
    object-fit: contain;
  }

  .withImage + .content-area {
    margin-top: 0;
  }

  .content-area {
    background-color: white;
    max-width: 1300px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    color: var(--c-primary-neutral-1);
    display: flex;
    justify-content: center;

    h1,
    h2 {
      width: 100%;
    }

    h1 {
      font-family: 'Faustina', serif;
      font-weight: 700;
      font-size: 24px;
      line-height: 1;
      margin-top: 20px;
      margin-bottom: 20px;
      text-align: left;
      color: var(--c-primary-neutral-1);

      &:empty {
        display: none;
      }
    }

    h2 {
      font-family: 'Faustina', serif;
      color: var(--c-primary-neutral-1);
      font-size: 15px;
      margin-bottom: 20px;
      line-height: 1;

      &:empty {
        display: none;
      }
    }

    h1 + h2 {
      margin-top: -10px;
    }

    .content-column {
      width: auto;
      display: inline-block;
      margin: 0;
      max-width: 100%;
      padding: 0 10px;
    }
  }

  .content-area--no-image {
    margin-top: 0;

    h2 {
      margin-bottom: 50px;
    }

    h1 + h2 {
      margin-top: -15px;
    }

    .content-column {
      padding-top: 25px;
    }
  }
}

@media (--xs) {
  .sanitasHealthForecastOverview {
    margin-left: calc(-1 * var(--body-offset-horizontal));
    margin-right: calc(-1 * var(--body-offset-horizontal));

    .header-image.right {
      padding-top: 50px;
    }

    .content-area {
      h1 {
        margin-top: 40px;
        margin-bottom: 40px;
        font-size: 60px;
      }

      h2 {
        font-size: 36px;
        margin-bottom: 50px;
      }
    }
  }
}

@media (min-width: 730px) {
  .sanitasHealthForecastOverview {
    .content-area {
      h1,
      h2 {
        width: 80%;
      }
    }
  }
}

@media (min-width: 860px) {
  .sanitasHealthForecastOverview {
    .content-area {
      h2 {
        margin-bottom: 100px;
      }

      .content-column {
        padding: 0;
        max-width: auto;
        margin: 0 30px;
        width: 1100px;
      }
    }

    .content-area--no-image .content-column {
      padding-top: 0;
    }

    .header-image {
      min-height: 100%;
      max-width: 1200px;
      max-height: 720px;

      .cover {
        object-position: top;
      }
    }

    .header-img {
      width: 200px;
      height: auto;
    }
  }
}

@media (min-width: 1160px) {
  .sanitasHealthForecastOverview {
    .header-img {
      width: 287px;
      height: 368px;
      margin-right: 0;
    }

    .content-area. .content-column {
      margin: 0 auto;
    }
  }
}

@media (--xl) {
  .sanitasHealthForecastOverview {
    margin-left: calc(-1 * var(--body-offset-horizontal));
    margin-right: calc(-1 * var(--body-offset-horizontal));

    .header-image {
      min-height: 780px;
      max-width: 1680px;
      max-height: 780px;
    }

    .content-area h1 {
      margin-top: 60px;
    }

    .withImage + .content-area {
      margin-top: -200px;
    }
  }
}
</style>
